import * as React from 'react';
import GeneralEducationApiService from '../../../api/GeneralEducationApiService';
import Routes from '../../../config/Routes';
import FeatureFlag from '../../../consts/FeatureFlag';
import GeneralEducationDTO from '../../../models/GeneralEducationDTO';
import TableRequestDTO from '../../../models/TableRequestDTO';
import BaseDataTableState from '../../../redux/bases/BaseDataTableState';
import BaseFormProps from '../../../redux/bases/BaseFormProps';
import BaseFormState from '../../../redux/bases/BaseFormState';
import AuthorizationUtil from '../../../utils/AuthorizationUtil';
import DateUtil from '../../../utils/DateTimeUtil';
import FileDownload from '../../../utils/FileDownload';
import HistoryUtil from '../../../utils/HistoryUtil';
import DataTable, { ColumnType, DataTableColumnProps, FilterType } from '../core/DataTable';
import DataTableButtonUtil from '../core/DataTableButtonUtil';
import DataTableCellRendererUtil from '../core/DataTableCellRendererUtil';

interface GeneralEducationDataTableProps extends BaseFormProps {
}

interface GeneralEducationDataTableState extends BaseDataTableState<GeneralEducationDTO>, BaseFormState {
}

class GeneralEducationDataTable extends React.Component<GeneralEducationDataTableProps, GeneralEducationDataTableState> {
  private _dataTable: DataTable<GeneralEducationDTO> | undefined;

  constructor(props: GeneralEducationDataTableProps) {
    super(props);
    this.state = {
    };
  }

  private getColumnDefinitions = () => {
    return [
      {
        title: 'Display',
        dataIndex: GeneralEducationDTO.displayOrder,
        width: 50,
        sorter: true,
        filterType: FilterType.NONE
      },
      {
        title: 'Code',
        dataIndex: GeneralEducationDTO.code,
        width: 50,
        sorter: true,
        filterType: FilterType.Text
      },
      {
        title: 'Name',
        dataIndex: GeneralEducationDTO.name,
        sorter: true,
        filterType: FilterType.Text
      },
      {
        title: 'Embedded Credits',
        dataIndex: GeneralEducationDTO.embeddedCredits,
        filterType: FilterType.BooleanRadio,
        columnType: ColumnType.Boolean,
        render: DataTableCellRendererUtil.BooleanYesEmpty,
        sorter: true,
        width: 135
      },
      {
        title: 'Parent',
        dataIndex: GeneralEducationDTO.parentGeneralEducationId,
        filterType: FilterType.Text,
        sorter: true,
        render: (value: number, row: GeneralEducationDTO) => {
          return row.parent?.name;
        },
      }
    ] as DataTableColumnProps<any>[];
  };

  private openGeneralEducation = (record: GeneralEducationDTO) => {
    if (record.id) {
      HistoryUtil.push(Routes.generate(Routes.GENERAL_EDUCATION_DETAILS, { id: record.id }, {}));
    }
  }

  private addGeneralEducation = () => {
    HistoryUtil.push(Routes.generate(Routes.NEW_GENERAL_EDUCATION));
  }

  render() {
    const actionButtons = [];

    actionButtons.push(DataTableButtonUtil.Reset());
    actionButtons.push(
      DataTableButtonUtil.Export(
        (tableRequest: TableRequestDTO) => {
          this.setState({ exporting: true });
          return GeneralEducationApiService.getGeneralEducationDataTableExport(tableRequest).then(file => {
            this.setState({ exporting: false });
            FileDownload.downloadBase64StringAsFile(`GeneralEducation_${DateUtil.getDateStamp()}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', file ?? undefined);
          });
        },
        this.state.exporting
      )
    );

    if (AuthorizationUtil.isAuthorized([FeatureFlag.EDIT_GENERAL_EDUCATION])) {
      actionButtons.push(DataTableButtonUtil.Default('New General Education', () => this.addGeneralEducation()));
    }

    return (
      <>
        <DataTable
          ref={(element: any) => (this._dataTable = element)}
          onRowClick={this.openGeneralEducation}
          serverSide={true}
          tableProps={{
            rowKey: 'id',
            scroll: { x: 500 }
          }}
          globalSearch={true}
          buttonBar={actionButtons}
          columns={this.getColumnDefinitions()}
          fetchData={{
            fetch: (requestState: TableRequestDTO) => GeneralEducationApiService.getGeneralEducationsDataTable(requestState)
          }}
          stateSaving={{ enabled: true, tableUniqueKey: 'generalEducation_list' }} />
      </>
    );
  }
}

export default GeneralEducationDataTable;
